import { Tabs, Grid } from '@mui/material'
import Tab from './tab'
import React, { useState } from 'react'
import { useStyles } from './style'

const FilterBarTabs = props => {
  const { tabs } = props
  const [value, setValue] = useState(false)
  const classes = useStyles({ ...props, selected: value })

  const handleChange = (event, newValue) => {
    console.log({ newValue, value, event })

    setValue(newValue === value ? false : newValue)
  }

  return (
    <>
      <Tabs
        value={value}
        // onChange={handleChange}
        // onChangeCapture={handleChange}
        aria-label='Filter tabs'
        classes={{ root: classes.tabs, indicator: classes.indicator }}
      >
        {tabs.map((tab, idx) => (
          <Tab key={tab.label} label={tab.label} icon={tab.icon} onClick={(evt) => handleChange(evt, idx)} data-test={`tab-${tab.label}`} />
        ))}
      </Tabs>
      {tabs.map((tab, idx) => (
        <TabPanel key={tab.label} value={value} index={idx}>
          {tab.component}
        </TabPanel>
      ))}
    </>
  )
}

export default FilterBarTabs

const TabPanel = props => {
  const { children, value, index, ...other } = props
  const classes = useStyles(props)

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`filter-tabpanel-${index}`}
      aria-labelledby={`filter-tab-${index}`}
      {...other}
    >
      <Grid
        container
        alignItems='center'
        spacing={1}
        wrap='nowrap'
        classes={{ root: classes.panel }}
      >
        {children}
      </Grid>
    </div>
  )
}
